// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"cdacd0a9","298":"d56ed0fb","453":"a5d3b9ee","888":"44be4f4b"}[chunkId] + ".chunk.js";
};